const LOCAL_ENV = "local";
const API_URL = process.env.REACT_APP_API_URL;
export const BASE_URL = ((env) => {
  switch (env) {
    //ADD OTHER URL
    case "production":
      return "https://api.rosemount.edu.np";

    case LOCAL_ENV:
      return API_URL || "http://localhost:8000";

    default:
      return API_URL || "http://localhost:8000";
  }
})(process.env.REACT_APP_ENV);
